// Registro do Service Worker - OTIMIZAÇÃO FASE 3

export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/sw.js`;

      navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
          // Atualização automática
          registration.onupdatefound = () => {
            const installingWorker = registration.installing;
            if (installingWorker == null) {
              return;
            }
            installingWorker.onstatechange = () => {
              if (installingWorker.state === 'installed') {
                if (navigator.serviceWorker.controller) {
                  console.log('Nova versão disponível!');
                  // Aqui você pode mostrar uma notificação para o usuário
                } else {
                  console.log('Conteúdo cacheado para uso offline');
                }
              }
            };
          };
        })
        .catch((error) => {
          console.error('Erro durante o registro do service worker:', error);
        });
    });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}

// Função para verificar se está online
export function isOnline() {
  return navigator.onLine;
}

// Função para sincronizar dados quando voltar online
export function syncWhenOnline() {
  window.addEventListener('online', () => {
    console.log('Conexão restaurada. Sincronizando dados...');
    // Aqui você pode implementar a sincronização de dados
  });
}

// Função para mostrar status offline
export function showOfflineStatus() {
  window.addEventListener('offline', () => {
    console.log('Conexão perdida. Modo offline ativado.');
    // Aqui você pode mostrar uma notificação para o usuário
  });
}
